/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import mutations from './modulePageMutations.js'
import actions from './modulePageActions.js'
import getters from './modulePageGetters.js'

export default {
	namespaced: true,
    state: "",
    mutations: mutations,
    actions: actions,
    getters: getters
}
